import { render, staticRenderFns } from "./CreateTestModal.vue?vue&type=template&id=3c11ea6f"
import script from "./CreateTestModal.vue?vue&type=script&lang=js"
export * from "./CreateTestModal.vue?vue&type=script&lang=js"
import style0 from "./CreateTestModal.vue?vue&type=style&index=0&id=3c11ea6f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports